import { useIsVault } from "../util/utils.js";
import { ProfileBar } from "./ProfileBar.js";
import { ProfileBarVault } from "./ProfileBarVault.js";
import { useWindowSettings, useProfile } from "./ProfileContext.js";
import { BottomMenu } from "./BottomMenu.js";
import Navbars from './Navbar.js'
export function PageContainer(props) {
	let [profile, setProfile] = useProfile();
	let isVault = useIsVault();
	let isLoggedIn = (profile != null);

	return (
		<div className={`outer-container ${(!isLoggedIn) && "logged-out"} display-context-${isVault ? "vault" : "app"}`}>
			<div className={`${(!isLoggedIn) && "logged-out"}`}>
				{isLoggedIn && (!isVault) && <ProfileBar /> }
				{isLoggedIn && isVault && <ProfileBarVault />}
				<div className="page-container">				
					{props.children}
				</div>
				{isLoggedIn && <BottomMenu/>}
			</div>
		</div>
	)
}